var _circle, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCorporateBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 16.5,
    r: 16,
    fill: "#E6F6F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0353 11.25H8.11765C7.71805 11.25 7.39412 11.5858 7.39412 12V24C7.39412 24.4142 7.71805 24.75 8.11765 24.75H24.0353C24.4349 24.75 24.7588 24.4142 24.7588 24V12C24.7588 11.5858 24.4349 11.25 24.0353 11.25Z",
    stroke: "#00A0B1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6941 11.25V9.75C19.6941 9.35218 19.5417 8.97064 19.2703 8.68934C18.9989 8.40804 18.6308 8.25 18.2471 8.25H13.9059C13.5221 8.25 13.154 8.40804 12.8827 8.68934C12.6113 8.97064 12.4588 9.35218 12.4588 9.75V11.25",
    stroke: "#00A0B1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7588 16.3406C22.12 17.9226 19.1248 18.7538 16.0765 18.75C13.0276 18.7582 10.0313 17.9268 7.39412 16.3406",
    stroke: "#00A0B1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9912 15.75H17.1618",
    stroke: "#00A0B1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorporateBlue);
export default __webpack_public_path__ + "static/media/corporate-blue.13dab8c8b64ed8bb04d4b84a0224b71b.svg";
export { ForwardRef as ReactComponent };